/*
*  Copyright 2018 Adobe Systems Incorporated. All rights reserved.
*  This file is licensed to you under the Apache License, Version 2.0 (the "License");
*  you may not use this file except in compliance with the License. You may obtain a copy
*  of the License at http://www.apache.org/licenses/LICENSE-2.0
*
*  Unless required by applicable law or agreed to in writing, software distributed under
*  the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
*  OF ANY KIND, either express or implied. See the License for the specific language
*  governing permissions and limitations under the License.
*
*/

export const ERROR_STATE_MAP = {
	404: {
		icon: 'https://public.adobecc.com/files/1UJYSQ4XV3BA0TWBR41TSWNWCBHFFF/error404.png',
		title: 'app.errorpage.e400.title',
		detail: 'app.errorpage.e400.detail'
	},
	500: {
		icon: 'https://public.adobecc.com/files/1UJYSQ4XV3BA0TWBR41TSWNWCBHFFF/error500.png',
		title: 'app.errorpage.e500.title',
		detail: 'app.errorpage.e500.detail'
	},
	504: {
		icon: 'https://public.adobecc.com/files/1UJYSQ4XV3BA0TWBR41TSWNWCBHFFF/error504.png',
		title: 'app.errorpage.e504.title',
		detail: 'app.errorpage.e504.detail'
	}
};